<template>
  <div class="page-container">
    <!-- 面包屑 -->
    <el-breadcrumb class="page-breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店资料管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="card-box" shadow="hover">
      <!-- 搜索栏 -->
      <div class="search-wrapper">
        <el-form :inline="true" :model="searchForm" label-width="80px" autocomplete="on">
          <el-form-item label="文件名称" size="small">
            <el-input v-model="searchForm.name" clearable placeholder="请输入文件名称" style="width: 180px;"></el-input>
          </el-form-item>

          <el-form-item label="文件类型" size="small">
            <el-select v-model="searchForm.file_type" clearable placeholder="全部类型" style="width: 140px;">
              <el-option label="图片" value="image"></el-option>
              <el-option label="文档" value="doc"></el-option>
              <el-option label="PDF" value="pdf"></el-option>
              <el-option label="其他" value="other"></el-option>
            </el-select>
          </el-form-item>

          <!-- 所属门店：修复检索 -->
          <el-form-item label="所属门店" size="small">
            <el-select
              v-model="searchForm.shop_id"
              filterable
              clearable
              placeholder="搜索门店/地址/联系人"
              style="width: 280px;"
              :filter-method="shopFilterMethod"
              popper-class="shop-select-dropdown"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                class="shop-option-item"
              >
                <div class="shop-option">
                  <div class="shop-name">{{ item.name }}</div>
                  <div class="shop-info">
                    <span>地址：{{ item.address || '无' }}</span>
                    <span>联系人：{{ item.contact || '无' }}</span>
                  </div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="search-btns">
          <el-button type="success" icon="el-icon-search" size="small" @click="searchSubmit">搜索</el-button>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addData">新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        border
        :data="tableLoadData"
        style="width: 100%; margin-top: 20px"
        row-key="id"
        stripe
        size="mini"
        header-cell-class-name="table-header"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>

        <el-table-column label="预览" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.file_type === 'image'" style="padding-top:4px">
              <el-image :src="scope.row.file_url" fit="cover" style="width:44px;height:44px;border-radius:4px;cursor: pointer"
                preview-src-list="[scope.row.file_url]"></el-image>
            </div>
            <div v-else style="font-size:26px;color:#909399;padding-top:4px">
              <i class="el-icon-document"></i>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="文件名称" prop="name" min-width="180" />
        <el-table-column label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getFileTypeTag(scope.row.file_type)" effect="plain">
              {{ scope.row.file_type | fileTypeFilter }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="大小" width="120" prop="file_size" align="center" />
        <el-table-column label="所属门店" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.shop?.name }}</div>
            <div style="font-size:12px;color:#909399;">{{ scope.row.shop?.address }}</div>
          </template>
        </el-table-column>
        <el-table-column label="上传时间" width="170" align="center">
          <template slot-scope="scope">{{ scope.row.add_time | dateFormat }}</template>
        </el-table-column>

        <el-table-column label="操作" width="260" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-view" size="mini" @click="previewFile(scope.row)">预览</el-button>
            <el-button type="warning" icon="el-icon-edit" size="mini" @click="handelEdit(scope.row)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="goDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹窗 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" class="dialog-style">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="small" :inline-message="false">
        <el-form-item label="文件名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入文件名称"></el-input>
        </el-form-item>

        <el-form-item label="文件类型" prop="file_type">
          <el-select v-model="form.file_type" placeholder="请选择文件类型">
            <el-option label="图片" value="image"></el-option>
            <el-option label="文档" value="doc"></el-option>
            <el-option label="PDF" value="pdf"></el-option>
            <el-option label="其他" value="other"></el-option>
          </el-select>
        </el-form-item>

        <!-- 弹窗门店：修复检索 -->
        <el-form-item label="所属门店" prop="shop_id">
          <el-select
            v-model="form.shop_id"
            filterable
            clearable
            placeholder="搜索门店/地址/联系人"
            :filter-method="shopFilterMethod"
            popper-class="shop-select-dropdown"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              class="shop-option-item"
            >
              <div class="shop-option">
                <div class="shop-name">{{ item.name }}</div>
                <div class="shop-info">
                  <span>地址：{{ item.address || '无' }}</span>
                  <span>联系人：{{ item.contact || '无' }}</span>
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :file-list="fileList"
            accept=".jpg,.png,.jpeg,.pdf,.doc,.docx,.xls,.xlsx"
            :show-file-list="true"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持 图片 / PDF / Word / Excel</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="文件大小">
          <el-input v-model="form.file_size" disabled placeholder="上传后自动获取"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 预览弹窗 -->
    <el-dialog title="文件预览" :visible.sync="previewDialog" width="860px" append-to-body class="dialog-prev">
      <div style="text-align:center; padding:20px 0">
        <img v-if="previewInfo.type === 'image'" :src="previewInfo.url" style="max-width:100%;max-height:520px;border-radius:6px" />
        <iframe v-else-if="previewInfo.type === 'pdf'" :src="previewInfo.url" width="100%" height="520px" frameborder="0"></iframe>
        <div v-else style="padding:80px 0">
          <el-button type="primary" icon="el-icon-download" @click="downLoadFile(previewInfo.url)">下载文件查看</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "ShopFileList",
  data() {
    return {
      searchForm: {
        name: "",
        file_type: "",
        shop_id: "",
      },
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      id: "",
      shopList: [],
      title: "",
      dialogFormVisible: false,
      form: {
        name: "",
        file_type: "",
        shop_id: "",
        file_url: "",
        file_size: ""
      },
      fileList: [],
      uploadUrl: "/api/upload",
      uploadHeaders: {
        access_token: sessionStorage.getItem("token")
      },
      previewDialog: false,
      previewInfo: { url: "", type: "" },
      rules: {
        name: [{ required: true, message: "请输入文件名称", trigger: "blur" }],
        file_type: [{ required: true, message: "请选择文件类型", trigger: "change" }],
        shop_id: [{ required: true, message: "请选择所属门店", trigger: "change" }]
      }
    };
  },
  created() {
    this.getShopList();
    this.getDataList();
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return "";
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    fileTypeFilter(type) {
      const map = { image: "图片", pdf: "PDF", doc: "文档", other: "其他" };
      return map[type] || type;
    }
  },
  methods: {
    // ✅ 修复：返回布尔值，Element UI 自动过滤
    shopFilterMethod(query, item) {
      if (!query) return true;
      const txt = (
        (item.name || '') +
        (item.address || '') +
        (item.contact || '')
      ).toLowerCase();
      return txt.includes(query.toLowerCase());
    },
    // 获取文件列表
    getDataList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        shop_id: this.searchForm.shop_id,
        name: this.searchForm.name,
        file_type: this.searchForm.file_type
      };
      this.$axios.getShopFileList(param).then(res => {
        if (res.code === 200) {
          this.tableLoadData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    // 上传成功
    handleUploadSuccess(res) {
      if (res.code === 200) {
        this.form.file_url = res.data.url;
        this.form.file_size = res.data.size || "";
        this.$message.success("上传成功");
      }
    },
    // 预览文件
    previewFile(row) {
      this.previewDialog = true;
      this.previewInfo.url = row.file_url;
      this.previewInfo.type = row.file_type;
    },
    // 下载
    downLoadFile(url) {
      window.open(url);
    },
    // 文件类型标签
    getFileTypeTag(type) {
      const tagMap = { image: "success", pdf: "warning", doc: "primary", other: "info" };
      return tagMap[type] || "info";
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getDataList();
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    // 搜索
    searchSubmit() {
      this.pageNum = 1;
      this.getDataList();
    },
    // 新增
    addData() {
      this.title = "新增门店资料";
      this.dialogFormVisible = true;
      this.id = "";
      this.form = { name: "", file_type: "", shop_id: "", file_url: "", file_size: "" };
      this.fileList = [];
    },
    // 编辑
    handelEdit(row) {
      this.title = "编辑门店资料";
      this.id = row.id;
      this.dialogFormVisible = true;
      this.form = {
        name: row.name,
        file_type: row.file_type,
        shop_id: row.shop_id,
        file_url: row.file_url,
        file_size: row.file_size
      };
      this.fileList = row.file_url ? [{ name: row.name, url: row.file_url }] : [];
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const param = {
            id: this.id,
            name: this.form.name,
            file_type: this.form.file_type,
            shop_id: this.form.shop_id,
            file_url: this.form.file_url,
            file_size: this.form.file_size,
            company_id: sessionStorage.getItem("company_id"),
            access_token: sessionStorage.getItem("token")
          };
          this.$axios.saveShopFile(param).then(res => {
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.dialogFormVisible = false;
              this.getDataList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    // 删除
    goDel(row) {
      this.$confirm("确定删除该文件？删除后不可恢复！", "提示", { type: "warning" }).then(() => {
        const param = { id: row.id, access_token: sessionStorage.getItem("token") };
        this.$axios.delShopFile(param).then(res => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getDataList();
          }
        });
      });
    },
    // 获取门店列表
    getShopList() {
      const param = {
        proxy_id: sessionStorage.getItem("proxy_id"),
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token")
      };
      this.$axios.shopList(param).then(res => {
        if (res.code === 200) this.shopList = res.data;
      });
    },
    // 重置
    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => this.$refs[formName].resetFields());
    }
  }
};
</script>

<style scoped>
.page-container {
  padding: 20px 24px;
  background: #f5f7fa;
  min-height: calc(100vh - 80px);
}
.page-breadcrumb {
  margin-bottom: 16px;
  font-size: 13px;
  color: #666;
}
.card-box {
  border-radius: 12px;
  overflow: hidden;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.search-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.search-btns {
  display: flex;
  gap: 10px;
}

/* 下拉样式（保持不变） */
:deep(.shop-select-dropdown .el-select-dropdown__wrap) {
  max-height: 400px !important;
  overflow-y: auto;
}
:deep(.shop-option-item) {
  height: auto !important;
  padding: 8px 12px !important;
  white-space: normal !important;
  line-height: 1.5 !important;
}
.shop-option {
  line-height: 1.5;
}
.shop-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}
.shop-info {
  font-size: 12px;
  color: #909399;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

/* 表格表头 */
:deep(.table-header) {
  background-color: #f9fafb !important;
  font-weight: 500;
  color: #333;
}
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
:deep(.dialog-style) {
  border-radius: 10px;
  overflow: hidden;
}
:deep(.dialog-prev) {
  border-radius: 10px;
}
:deep(.el-upload__tip) {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
</style>